module.exports = __webpack_public_path__ + "media/fes.fa60a77b.mp3";